module.exports = __webpack_public_path__ + "static/media/HouseSmartTopShape.270f1bb9.svg";